import { render } from "./InfiniteSlider.vue?vue&type=template&id=4564a971&scoped=true"
import script from "./InfiniteSlider.vue?vue&type=script&lang=js"
export * from "./InfiniteSlider.vue?vue&type=script&lang=js"

import "./InfiniteSlider.vue?vue&type=style&index=0&id=4564a971&scoped=true&lang=scss"

import exportComponent from "/home/marko/Documents/Projects/praksa/petikom-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4564a971"]])

export default __exports__